"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/function-component-definition */
const react_1 = __importStar(require("react"));
const assets_1 = require("~/assets");
const RadioButton_scss_1 = __importDefault(require("./RadioButton.scss"));
const RadioButton = ({ children, onSelect, selected }) => {
    const [active, setActive] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => setActive(selected), [selected]);
    const toggleRadio = () => {
        onSelect();
        if (!active) {
            setActive((current) => !current);
        }
    };
    return (react_1.default.createElement("div", { className: RadioButton_scss_1.default.container, onClick: toggleRadio },
        react_1.default.createElement("img", { src: active ? assets_1.svgSystemRadioButtonEnabledActive : assets_1.svgSystemRadioButtonEnabledInactive, className: RadioButton_scss_1.default.radio }),
        react_1.default.createElement("div", { className: RadioButton_scss_1.default.children }, children)));
};
exports.default = RadioButton;
